import { useEffect, useRef, useState } from 'react'

import HooksModule from '../../modules/hooks/Module'
import DevLog from '../../modules/devlog/Module'

import { IAction } from '../../actions/types'
import { ISessionUseCurrentActionState } from '../types'

const DEBUG_ACTIONS = 'development' === process.env.NODE_ENV

let actionKeyCounter = 0
const actionKeyMap = new WeakMap<IAction, number>()

const useCurrentActionState: ISessionUseCurrentActionState = action => {
  const [currentAction, setCurrentAction] = useState<IAction>(action)

  const lastActionRef = useRef<IAction>(null)
  const currentActionRef = useRef<IAction>(null)
  if (currentActionRef.current !== currentAction) {
    lastActionRef.current = currentActionRef.current
    if (HooksModule.hasActionHook) {
      const hookAction = HooksModule.doAction(currentAction)
      if (hookAction && hookAction !== currentAction) {
        currentActionRef.current = hookAction
        setCurrentAction(hookAction)
      } else {
        currentActionRef.current = currentAction
      }
    } else {
      currentActionRef.current = currentAction
    }
    if (DEBUG_ACTIONS) {
      DevLog._log('SW(action):', currentActionRef.current)
    }
  }

  useEffect(() => {
    if (currentActionRef.current !== action) {
      setCurrentAction(action)
    }
  }, [action])

  return {
    currentActionRef,
    lastActionRef,
    setCurrentAction,
    currentActionKey: currentActionRef.current
      ? actionKeyMap.has(currentActionRef.current)
        ? actionKeyMap.get(currentActionRef.current)
        : (actionKeyCounter++, actionKeyMap.set(currentActionRef.current, actionKeyCounter), actionKeyCounter)
      : null
  } as const
}

export default useCurrentActionState
